document.addEventListener('DOMContentLoaded', () => {
	const buttons = document.querySelectorAll('.js-story-read-more');

	buttons.forEach((button) => {
		const wrapper = button.closest('.rmh-story-single__body');
		if (!wrapper) {
			return;
		}

		const content = wrapper.querySelector('[data-story-content]');
		const buttonContainer = button.closest('[data-story-read-more]');
		if (!content) {
			return;
		}

		button.addEventListener('click', () => {
			content.setAttribute('data-expanded', 'true');
			button.setAttribute('aria-expanded', 'true');
			if (buttonContainer) {
				buttonContainer.remove();
			}
		});
	});
});
